/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

// Enum to allow relevant redux fields to have multiple instances based on ISAN Portal and UP
// (similar to OverlayContextsEnum)
export enum PortalsEnum {
  UNIFIED_PORTAL = 'Unified Portal', // Unified Portal
  ISAN_PORTAL = 'ISAN Portal', // Integrated Space Access Node (ISAN) Portal for NASA CSP
}
